import moment from "moment";
import { regexEmail, regexWhithoutSpace } from ".";

export function cpfValidator(value, isBrazilian = true) {
	if (isBrazilian && value === "") return null;
	return isCPFValid(value);
}

export function isCPFValid(cpf) {
	cpf = cpf.replace(/\D/g, "");
	let soma;
	let resto;
	soma = 0;
	if (
		[
			"00000000000",
			"11111111111",
			"22222222222",
			"33333333333",
			"44444444444",
			"55555555555",
			"66666666666",
			"77777777777",
			"88888888888",
			"99999999999",
		].includes(cpf)
	)
		return false;

	for (let i = 1; i <= 9; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (11 - i);
	resto = (soma * 10) % 11;

	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(9, 10))) return false;

	soma = 0;
	for (let i = 1; i <= 10; i++) soma = soma + parseInt(cpf.substring(i - 1, i)) * (12 - i);
	resto = (soma * 10) % 11;

	if (resto === 10 || resto === 11) resto = 0;
	if (resto !== parseInt(cpf.substring(10, 11))) return false;
	return true;
}

export function validator(key, value, isBrazilian = true) {
	const validators = {
		CPF: () => {
			if (isBrazilian && String(value) === "") return null;
			return isCPFValid(String(value));
		},
		CREDIT_CARD_NUMBER: () => isCreditCardNumberValid(String(value)),
		NAME_COMPOUND: () => nameCompound(String(value)),
		CREDIT_CARD_DATE_EXPIRE: () => isDateExpireCreditCardValid(value),
	};

	return Boolean(validators[key]());
}

export function nameCompound(name) {
	return name.split(" ").length > 1;
}

export function isCreditCardNumberValid(ccNum) {
	var visaRegEx = /^(?:4[0-9]{12}(?:[0-9]{3})?)$/;
	var mastercardRegEx = /^(?:5[1-5][0-9]{14})$/;
	var amexpRegEx = /^(?:3[47][0-9]{13})$/;
	var discovRegEx = /^(?:6(?:011|5[0-9][0-9])[0-9]{12})$/;
	var isValid = true;

	if (visaRegEx.test(ccNum)) {
		isValid = true;
	} else if (mastercardRegEx.test(ccNum)) {
		isValid = true;
	} else if (amexpRegEx.test(ccNum)) {
		isValid = true;
	} else if (discovRegEx.test(ccNum)) {
		isValid = true;
	} else if (ccNum.length !== 16) {
		isValid = false;
	}

	return isValid;
}

export function isDateExpireCreditCardValid(date) {
	const month = date.substring(0, 2);
	const year = date.substring(2, 6);
	const newDateRef = Number(`${year}${month}`);
	const currentYearMonth = parseInt(moment().format("YYYYMM"));

	if (date.length !== 6) return false;

	if (Number(month) > 12) return false;

	if (newDateRef < currentYearMonth) return false;

	return true;
}

export function validateEmail(email) {
	return regexEmail.test(String(email).toLowerCase().trim()) && !regexWhithoutSpace.test(email);
}

/**
 *
 * @param {string} value
 * @returns {{valid: boolean, document: "CPF" | "CNPJ" | "documento"}}
 */
export function isValidCPFOrCNPJ(value) {
	if (!value) return { valid: false, document: "CPF ou CNPJ" };

	const digits = value.replace(/[^\d]+/g, "");

	if (digits.length === 11) {
		return validateCPF(digits);
	} else if (digits.length === 14) {
		return validateCNPJ(digits);
	}

	return { valid: false, document: "documento" };
}

function validateCPF(cpf) {
	if (/^(\d)\1+$/.test(cpf)) return { valid: false, document: "CPF" };

	const numbers = cpf.split("").map(Number);

	const calcCheckDigit = (arr, factor) => {
		const sum = arr.reduce(
			(acc, num) => {
				acc.sum += num * acc.weight--;
				return acc;
			},
			{ sum: 0, weight: factor }
		).sum;

		const rest = (sum * 10) % 11;
		return rest === 10 ? 0 : rest;
	};

	const firstDigit = calcCheckDigit(numbers.slice(0, 9), 10);
	const secondDigit = calcCheckDigit(numbers.slice(0, 10), 11);

	return { valid: firstDigit === numbers[9] && secondDigit === numbers[10], document: "CPF" };
}

function validateCNPJ(cnpj) {
	if (/^(\d)\1+$/.test(cnpj)) return { valid: false, document: "CNPJ" };

	const numbers = cnpj.split("").map(Number);

	const calcCheckDigit = (arr, weights) => {
		const sum = arr.reduce((acc, digit, index) => acc + digit * weights[index], 0);
		const rest = sum % 11;
		return rest < 2 ? 0 : 11 - rest;
	};

	const firstWeights = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
	const secondWeights = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

	const firstDigit = calcCheckDigit(numbers.slice(0, 12), firstWeights);
	const secondDigit = calcCheckDigit([...numbers.slice(0, 12), firstDigit], secondWeights);

	return { valid: firstDigit === numbers[12] && secondDigit === numbers[13], document: "CNPJ" };
}
